import type { CollectionCodeSnippetOptions } from './types';
import { getCollectionRestSnippet } from './rest';
import { getCollectionSdkSnippet } from './sdk';

/**
 * Generates both SDK and REST snippets for the requested collection operation.
 */
export function getCollectionCodeSnippets(options: CollectionCodeSnippetOptions): { sdk: string; rest: string } {
	return {
		sdk: getCollectionSdkSnippet(options),
		rest: getCollectionRestSnippet(options),
	};
}
